import { getSsoUrl } from '@/apiEndpoints';

const PASSWORD_ACCOUNT_CONFLICT = 'registered with email and password';

export function isPasswordAccountConflict(message?: string | null): boolean {
    return !!message && message.toLowerCase().includes(PASSWORD_ACCOUNT_CONFLICT);
}

export function getSsoErrorMessage(error: any, provider: string): string {
    const status = error?.response?.status;
    const message = error?.response?.data?.message;
    if (status && status < 500 && typeof message === 'string' && message.trim()) {
        return message;
    }
    return `${provider} login failed. Please try again.`;
}

export function getResetErrorMessage(error: any, fallback: string): string {
    const status = error?.response?.status;
    if (!error?.response) return 'Network error. Check your connection and try again.';
    if (status === 429) return 'Too many attempts. Please wait a moment and try again.';
    const message = error?.response?.data?.message;
    if (status && status < 500 && typeof message === 'string' && message.trim()) {
        return Array.isArray(message) ? message[0] : message;
    }
    return fallback;
}

export function isExpiredCodeMessage(message: string): boolean {
    return message.toLowerCase().includes('expired');
}

const SSO_RETRY_KEY = 'ssoLinkRetry';

export async function retrySsoAfterLink(error: any, provider: string): Promise<boolean> {
    if (error?.response?.data?.code !== 'SSO_ACCOUNT_LINKED') return false;
    try {
        if (sessionStorage.getItem(SSO_RETRY_KEY)) {
            sessionStorage.removeItem(SSO_RETRY_KEY);
            return false;
        }
        sessionStorage.setItem(SSO_RETRY_KEY, '1');
    } catch {
        return false;
    }
    try {
        const urls = await getSsoUrl();
        const url = urls?.[`${provider}Web`];
        if (!url) return false;
        window.location.href = url;
        return true;
    } catch {
        return false;
    }
}

export function clearSsoRetry() {
    try {
        sessionStorage.removeItem(SSO_RETRY_KEY);
    } catch {
        return;
    }
}
